var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { useCallback, useEffect, useState } from "react";
import { useWeb3React } from "@web3-react/core";
import axios from "axios";
import { BigNumber } from "ethers";
import { impersonateAddress } from "../utils/development";
import { getSubgraphURIForVersion, VaultAddressMap, VaultVersionList, } from "../constants/constants";
import { initialVaultAccounts, useGlobalState } from "../store/store";
var useVaultAccounts = function (vaults, variant, _a) {
    var _b = _a === void 0 ? { poll: false, pollingFrequency: 5000 } : _a, poll = _b.poll, _c = _b.pollingFrequency, pollingFrequency = _c === void 0 ? 5000 : _c;
    var web3Context = useWeb3React();
    var account = impersonateAddress || web3Context.account;
    var _d = useGlobalState("vaultAccounts"), vaultAccounts = _d[0], setVaultAccounts = _d[1];
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    var loadVaultAccounts = useCallback(function (_vaultOptions, _variant, acc, isInterval) {
        if (isInterval === void 0) { isInterval = true; }
        return __awaiter(void 0, void 0, void 0, function () {
            var results;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isInterval) {
                            setLoading(true);
                        }
                        return [4 /*yield*/, fetchVaultAccounts(_vaultOptions, _variant, acc)];
                    case 1:
                        results = _a.sent();
                        setVaultAccounts(function (curr) {
                            var _a;
                            return (__assign(__assign({}, curr), (_a = {}, _a[_variant] = __assign(__assign({}, curr[_variant]), results), _a)));
                        });
                        if (!isInterval) {
                            setLoading(false);
                        }
                        return [2 /*return*/];
                }
            });
        });
    }, [setVaultAccounts]);
    useEffect(function () {
        if (!account) {
            setVaultAccounts(initialVaultAccounts);
            return;
        }
        var pollInterval = undefined;
        if (poll) {
            loadVaultAccounts(vaults, variant, account, false);
            pollInterval = setInterval(loadVaultAccounts, pollingFrequency, vaults, variant, account);
        }
        else {
            loadVaultAccounts(vaults, variant, account, false);
        }
        return function () {
            if (pollInterval) {
                clearInterval(pollInterval);
            }
        };
    }, [
        vaults,
        variant,
        account,
        loadVaultAccounts,
        poll,
        pollingFrequency,
        setVaultAccounts,
    ]);
    return { vaultAccounts: vaultAccounts[variant], loading: loading };
};
var fetchVaultAccounts = function (vaults, variant, account) { return __awaiter(void 0, void 0, void 0, function () {
    var vaultVersions, vaultAccountsAcrossVersion, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                switch (variant) {
                    case "all":
                        vaultVersions = __spreadArray([], VaultVersionList);
                        break;
                    default:
                        vaultVersions = [variant];
                }
                _b = (_a = Object).fromEntries;
                return [4 /*yield*/, Promise.all(vaultVersions.map(function (version) { return __awaiter(void 0, void 0, void 0, function () {
                        var response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, axios.post(getSubgraphURIForVersion(version), {
                                        query: "\n          {\n            " + vaults
                                            .map(function (vault) {
                                            var vaultAddress = VaultAddressMap[vault][version];
                                            if (!vaultAddress) {
                                                return undefined;
                                            }
                                            return "     \n                  " + vault.replace(/-/g, "") + ": vaultAccount(id:\"" + vaultAddress.toLowerCase() + "-" + account.toLowerCase() + "\") {\n                    totalDeposits\n                    totalYieldEarned\n                    totalBalance\n                    totalStakedBalance\n                    totalStakedShares\n                    vault {\n                      symbol\n                    }\n                  }\n                ";
                                        })
                                            .filter(function (query) { return query; }) + "\n          }\n          ",
                                    })];
                                case 1:
                                    response = _a.sent();
                                    return [2 /*return*/, [
                                            version,
                                            Object.fromEntries(vaults.map(function (vault) {
                                                var data = response.data.data
                                                    ? response.data.data[vault.replace(/-/g, "")]
                                                    : false;
                                                if (!data) {
                                                    return [vault, undefined];
                                                }
                                                return [
                                                    vault,
                                                    __assign(__assign({}, data), { totalDeposits: BigNumber.from(data.totalDeposits), totalYieldEarned: BigNumber.from(data.totalYieldEarned), totalBalance: BigNumber.from(data.totalBalance), totalStakedShares: BigNumber.from(data.totalStakedShares), totalStakedBalance: BigNumber.from(data.totalStakedBalance) }),
                                                ];
                                            })),
                                        ]];
                            }
                        });
                    }); }))];
            case 1:
                vaultAccountsAcrossVersion = _b.apply(_a, [_c.sent()]);
                // Combine vault account across different version
                return [2 /*return*/, Object.fromEntries(vaults.map(function (vault) {
                        var vaultAccount = undefined;
                        for (var i = 0; i < vaultVersions.length; i++) {
                            var currentVersionVaultAccount = vaultAccountsAcrossVersion[vaultVersions[i]][vault];
                            if (!vaultAccount) {
                                vaultAccount = currentVersionVaultAccount;
                                break;
                            }
                            vaultAccount = __assign(__assign({}, vaultAccount), { totalDeposits: vaultAccount.totalDeposits.add(currentVersionVaultAccount.totalDeposits), totalYieldEarned: vaultAccount.totalYieldEarned.add(currentVersionVaultAccount.totalYieldEarned), totalBalance: vaultAccount.totalBalance.add(currentVersionVaultAccount.totalBalance), totalStakedShares: vaultAccount.totalStakedShares.add(currentVersionVaultAccount.totalStakedShares), totalStakedBalance: vaultAccount.totalStakedBalance.add(currentVersionVaultAccount.totalStakedBalance) });
                        }
                        return [vault, vaultAccount];
                    }))];
        }
    });
}); };
export default useVaultAccounts;
//# sourceMappingURL=useVaultAccounts.js.map